import { type GlobalSearchResultTypeEnum } from '../enums'
import { type GlobalSearchItemMetadata } from '../GlobalSearchItemMetadata'

const EXPIRY_DAYS = 45
const EXPIRY_MS = EXPIRY_DAYS * 24 * 60 * 60 * 1000

export interface GlobalSearchRecentItemConstructor {
  type: GlobalSearchResultTypeEnum
  uuid: string
  id: string
  metadata: GlobalSearchItemMetadata
  lastAccessedAt: string
}

export class GlobalSearchRecentItem {
  readonly type: GlobalSearchResultTypeEnum
  readonly uuid: string
  readonly id: string
  readonly metadata: GlobalSearchItemMetadata
  readonly lastAccessedAt: string

  constructor(data: GlobalSearchRecentItemConstructor) {
    this.type = data.type
    this.uuid = data.uuid
    this.id = data.id
    this.metadata = data.metadata
    this.lastAccessedAt = data.lastAccessedAt
  }

  get isExpired(): boolean {
    const accessedAt = new Date(this.lastAccessedAt).getTime()

    if (Number.isNaN(accessedAt)) {
      return true
    }

    return Date.now() - accessedAt >= EXPIRY_MS
  }
}
